export default __webpack_public_path__ + "static/media/roi-strategy.140bcbb6.svg";